import { useContext } from "react";
import { useQuery } from "react-query";
import { ApiContext } from "../../contexts/ApiContext";
import { Asset } from "../../shared/interfaces/Asset";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useAssetsBySubstation(substationId?: number | string, callbacks?: QueryCallbacks<Asset[]>) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["assets", "byHVSubstation", substationId],
    queryFn: async () => {
      if (substationId) return await apiContext.assetApis.getAssetsByHVSubstation(substationId);
    },
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
